export const MONTHLY_CHECKOUT_START = 'MONTHLY_CHECKOUT_START';
export const MONTHLY_CHECKOUT_SUCCESS = 'MONTHLY_CHECKOUT_SUCCESS';
export const MONTHLY_CHECKOUT_FAILURE = 'MONTHLY_CHECKOUT_FAILURE';
export const MONTHLY_CHECKOUT_RESET = 'MONTHLY_CHECKOUT_RESET';
export const MONTHLY_CHECKOUT_RESPONSE_CHANGED = 'MONTHLY_CHECKOUT_RESPONSE_CHANGED';
export const MONTHLY_CHECKOUT_RESPONSE_REST_START = 'MONTHLY_CHECKOUT_RESPONSE_REST_START';
export const MONTHLY_CHECKOUT_DETAILS_START = 'MONTHLY_CHECKOUT_DETAILS_START';
export const MONTHLY_CHECKOUT_DETAILS_SUCCESS = 'MONTHLY_CHECKOUT_DETAILS_SUCCESS';
export const MONTHLY_CHECKOUT_DETAILS_FAILURE = 'MONTHLY_CHECKOUT_DETAILS_FAILURE';
